import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { FarmersService } from '~/api/services/farmers/index'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

interface Props {
  booking: any
  handleClose: (submited?: boolean) => void
}

const DeleteBooking: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { booking, handleClose } = props
  const { id } = useParams()

  const [isBusy, setIsBusy] = useState(false)

  async function handleSubmit() {
    setIsBusy(true)
    try {
      await FarmersService.deleteBookingHistory(id, booking?.id)
      handleClose(true)
      notify(t('Successfully delete article booking'), 'success')
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(booking)}
    isLoading={isBusy}
    handleClose={() => handleClose()}
    textHeader={t('Delete article booking')}
    textSubmit={t('Delete')}
    textClose={t('Cancel')}
    type={'abort'}
    handleSubmit={() => handleSubmit()}
    textContent={t('Do you really want to delete article booking: {{name}}', { name: booking?.name || '' })}
  />
}
export default DeleteBooking